import { Link, useParams } from 'react-router';

import { fetchCustomerOrderDetail } from '#/api/crmMgmt/customerOrder/fetchDetail';
import { updateCustomerOrderRemark } from '#/api/crmMgmt/customerOrder/updateRemark';
import { ROUTES } from '#/config/routes';
import useDocumentRemarkSave from '#/hooks/useDocumentRemarkSave';
import { Button } from '#/modules/commonComponents/button';
import CustomerOrderMainInfoCard from '#/modules/crmMgmt/customerOrder/components/CustomerOrderMainInfoCard';
import {
  getCustomerOrderApiErrorMessage,
  isCustomerOrderVersionConflict,
} from '#/modules/crmMgmt/customerOrder/helper/apiError';
import { canUpdateCustomerOrderRemark } from '#/modules/crmMgmt/customerOrder/helper/customerOrderStatus';
import DocumentRemarkEditForm from '#/modules/imsMgmt/receipts/shared/DocumentRemarkEditForm';
import PageShell from '#/modules/infra/layout/PageShell';
import {
  customerOrderDetailQueryKey,
  customerOrderListQueryKeyPrefix,
} from '#/utils/queryKeys';

const CustomerOrderRemarkPage = () => {
  const { id } = useParams();

  const {
    detail,
    detailQuery,
    isPending,
    saveRemark,
  } = useDocumentRemarkSave({
    id,
    fetchDetail: fetchCustomerOrderDetail,
    updateRemark: updateCustomerOrderRemark,
    detailQueryKey: customerOrderDetailQueryKey,
    listQueryKeyPrefix: customerOrderListQueryKeyPrefix,
    getErrorMessage: (error) => getCustomerOrderApiErrorMessage(error, '更新備註失敗'),
    isVersionConflict: isCustomerOrderVersionConflict,
    afterSaveNavigateTo: ROUTES.customerOrderDetail(id),
  });

  const isLoading = detailQuery.isLoading;
  const isError = detailQuery.isError;
  const remarkAllowed = detail ? canUpdateCustomerOrderRemark(detail.status) : false;

  return (
    <PageShell variant="form">
      <div className="layout-shell__body">
        <div className="mx-auto w-full max-w-4xl space-y-4">
          <div className="create_edit_page__header">
            <h1 className="page_title mb-0!">
              <span className="border-l-5 border-primary-400 pl-2.5">編輯客戶訂單備註</span>
            </h1>
            <Button type="button" variant="outline" asChild>
              <Link to={ROUTES.customerOrderDetail(id)}>返回詳情</Link>
            </Button>
          </div>

          {isLoading ? (
            <p className="text-sm text-slate-500">載入中…</p>
          ) : null}

          {isError ? (
            <p className="text-sm text-destructive">
              {getCustomerOrderApiErrorMessage(detailQuery.error, '找不到客戶訂單')}
            </p>
          ) : null}

          {detail && !remarkAllowed ? (
            <p className="text-sm text-slate-600">目前狀態不可編輯備註。</p>
          ) : null}

          {detail && remarkAllowed ? (
            <>
              <CustomerOrderMainInfoCard detail={detail} />
              <DocumentRemarkEditForm
                initialRemark={detail.remark ?? ''}
                cancelTo={ROUTES.customerOrderDetail(id)}
                isPending={isPending}
                onSave={saveRemark}
              />
            </>
          ) : null}
        </div>
      </div>
    </PageShell>
  );
};

export default CustomerOrderRemarkPage;
